  ;(function() {
    const bbTopBar = document.querySelector('.bb-top-bar')
    const timming = bbTopBar.getAttribute('data-timming')
    new Swiper(bbTopBar, {
      direction: 'vertical',
      slidesPerView: 1,
      grid: {
          fill: 'row',
          rows: 1,
      },
      autoplay: {
          delay: parseInt(timming) * 1000,
          disableOnInteraction: true
      },
    })
  })()